import { WithTheme } from '@issuemanager/apps/client/theme';
import {
  FormLabel,
  TextField as MuiTextField,
  TextFieldProps as MuiTextFieldProps,
  Stack,
} from '@mui/material';
import { styled } from '@mui/system';
import { JSX, ReactNode } from 'react';

export const StyledTextField = styled(MuiTextField)<WithTheme<TextFieldProps>>(
  ({ theme, inputProps }) => ({
    '.MuiInputBase-root': {
      backgroundColor: inputProps?.readOnly
        ? theme.tokens.semantic.color.background.disabled.value
        : theme.tokens.semantic.color.background.container.value,
      '& input::placeholder': {
        fontStyle: 'normal',
      },
    },
    '.MuiSelect-select': {
      paddingLeft: '0px !important',
    },
  }),
);

export type TextFieldExtraProps = {
  labelInfo?: ReactNode;
  'data-testid'?: string;
};

export type TextFieldProps = MuiTextFieldProps & TextFieldExtraProps;

export function TextField({
  name,
  label,
  labelInfo,
  required,
  InputLabelProps,
  ...props
}: TextFieldProps): JSX.Element {
  return (
    <Stack width='100%'>
      {label && (
        <FormLabel
          required={required}
          id={`${name}-label`}
          {...InputLabelProps}
        >
          {label}
        </FormLabel>
      )}

      {labelInfo && <FormLabel color='info'>{labelInfo}</FormLabel>}

      <StyledTextField {...props} data-aria-labelledby={`${name}-label`} />
    </Stack>
  );
}
